import { getListViewDimensions } from './getListViewDimensions';
import { LIST_VIEW_NOTIFICATION_PADDING_V9, MIN_LIST_VIEW_WIDTH } from '../internalConstants';

export function getListViewNotificationDimensions(): {
    minWidth: number;
    maxWidth: number;
} {
    const listViewWidth = getListViewDimensions().listViewWidth;

    return {
        minWidth: MIN_LIST_VIEW_WIDTH - LIST_VIEW_NOTIFICATION_PADDING_V9,
        maxWidth: listViewWidth - LIST_VIEW_NOTIFICATION_PADDING_V9,
    };
}
